/*!
 * devextreme-react
 * Version: 18.2.7
 * Build date: Sat Mar 09 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getNestedValue(obj, keyParts) {
    var current = obj;
    keyParts.some(function (part) {
        current = current[part];
        return current === undefined || current === null;
    });
    return current;
}
exports.getNestedValue = getNestedValue;
function addPrefixToKeys(obj, prefix) {
    var result = {};
    Object.keys(obj).forEach(function (key) { return result[prefix + key] = obj[key]; });
    return result;
}
exports.addPrefixToKeys = addPrefixToKeys;
function generateID() {
    return Math.random().toString(36).substr(2);
}
exports.generateID = generateID;
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
exports.isEmptyObject = isEmptyObject;



//////////////////
// WEBPACK FOOTER
// ./node_modules/devextreme-react/core/helpers.js
// module id = 1089
// module chunks = 2